import { __decorate } from "tslib";
import { ChameleonElementMixin } from '../common/mixin';
import { attr, html, observable, slotted } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
export const highlightTemplate = (context, definition) => html `
        <span class="content" part="content">
            <slot ${slotted('content')}></slot>
        </span>
`;
export class HighlightComponent extends ChameleonElementMixin(FoundationElement) {
    constructor() {
        super(...arguments);
        this.content = [];
        this.filterAttribute = undefined;
        this.highlightNode = (element, filter) => {
            if (!filter) {
                return null;
            }
            Array.from(element.childNodes).map((node) => {
                if (node.nodeType === Node.TEXT_NODE) {
                    this.highlightTextNode(node, filter);
                }
                else if (node.nodeType === Node.ELEMENT_NODE) {
                    this.highlightNode(node, filter);
                }
            });
        };
    }
    filterAttributeChanged(prev, next) {
        this.contentChanged(undefined, this.content);
    }
    highlightTextNode(node, filter) {
        const textContent = node?.textContent ?? '';
        const matches = match(textContent, filter, { insideWords: true, findAllOccurrences: true });
        const parts = parse(textContent, matches);
        let existingNode = node;
        parts.forEach((part) => {
            const remainingTextNode = existingNode.splitText(part.text.length);
            if (part.highlight) {
                const spanHighlight = document.createElement('span');
                spanHighlight.className = 'highlight';
                const copiedNode = existingNode.cloneNode();
                spanHighlight.appendChild(copiedNode);
                existingNode.replaceWith(spanHighlight);
            }
            existingNode = remainingTextNode;
        });
    }
    contentChanged(prev, next) {
        const contentSlot = this.shadowRoot?.querySelector('.content slot');
        contentSlot?.toggleAttribute('hidden', !!this.filterAttribute);
        this.shadowRoot?.querySelector('#internal-highlight')?.remove();
        if (this.filterAttribute) {
            const element = document.createElement('span');
            next.forEach((node) => {
                element.appendChild(node.cloneNode(true));
            });
            this.highlightNode(element, this.filterAttribute);
            element.id = 'internal-highlight';
            contentSlot?.parentElement?.appendChild(element);
        }
    }
}
__decorate([
    observable
], HighlightComponent.prototype, "content", void 0);
__decorate([
    attr({ attribute: 'filter' })
], HighlightComponent.prototype, "filterAttribute", void 0);
